<template>
  <router-link
    v-if="to"
    class="m-link"
    :target="target"
    :to="to"
    :class="{disabled: disabled}"
  >
    <MIcon
      v-if="icon && iconBeforeText"
      class="m-link__icon_before"
      :icon="icon"
    />
    <slot />
    <MIcon
      v-if="icon && iconAfterText"
      class="m-link__icon_after"
      :icon="icon"
    />
  </router-link>
  <a
    v-else
    class="m-link"
    :target="target"
    :href="href"
    :class="{disabled: disabled}"
    @click="handleClick"
  >
    <MIcon
      v-if="icon && iconBeforeText"
      class="m-link__icon m-link__icon_before"
      :icon="icon"
    />
    <slot />
    <MIcon
      v-if="icon && iconAfterText"
      class="m-link__icon m-link__icon_after"
      :icon="icon"
    />
  </a>
</template>

<script>
  import MIcon from 'components/Design/MIcon';

  export default {
    name: 'MLink',
    components: {MIcon},

    props: {
      href: {
        type: String,
        default: ''
      },
      to: {
        type: Object,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      icon: {
        type: Object,
        default: null
      },
      iconPosition: {
        type: String,
        default: 'before',
        choices: ['before', 'after']
      },
      target: {
        type: String,
        default: null
      }
    },
    computed: {
      iconBeforeText () {
        return this.iconPosition === 'before';
      },
      iconAfterText () {
        return this.iconPosition === 'after';
      }
    },
    methods: {
      handleClick (e) {
        if (!this.href) {

          // prevent href action if not href is specified
          e.preventDefault();
        }
        this.$emit('click', e);
      }
    }
  };
</script>

<style>
  .m-link {
    color: var(--action-color);

    vertical-align: middle;

    text-decoration: unset;

    cursor: pointer;

    display: inline-flex;

    align-items: center;

    /* deal with application.css */
    outline: unset;
    outline-offset: unset;

    &.disabled {
      color: var(--action-disabled-color);
      cursor: not-allowed;

      &:hover,
      &:focus {
        color: var(--action-disabled-color);
      }
    }

    &:focus {
      color: var(--action-color);
    }

    &:hover {
      color: var(--action-hover-color);
    }
  }

  .m-link svg {
    vertical-align: middle;
    height: 1.1em;
  }

  .m-link__icon_before {
    margin-right: 4px;
  }

  .m-link__icon_after {
    margin-left: 4px;
  }
</style>

